import React, { useEffect, useState, useRef } from "react";
import { toJS } from "mobx";
import Team from "./Team";
import { ResourceRequester } from "sulu-admin-bundle/services";
import styles from "./team-authorization.module.scss";
import { Loader } from "sulu-admin-bundle/components";
import { useTeamAuthorization } from "./TeamAuthorizationContext";

const TeamType = ({ teamData }) => {
    const [teamsData, setTeamsData] = useState({});
    const [allTeamsLoaded, setAllTeamsLoaded] = useState(false);
    const [loading, setLoading] = useState(true);
    const [activeTeams, setActiveTeams] = useState({});
    const { locale, showArchived } = useTeamAuthorization();

    useEffect(() => {
        const fetchAllData = async () => {
            !loading && setLoading(true);
            const selectedTeams = toJS(teamData);
            const teamsIds = Object.keys(selectedTeams).filter(Boolean);

            const missingTeamIds = showArchived
                ? teamsIds.filter((id) => !teamsData[id])
                : teamsIds;

            const allManagerIds = Object.values(selectedTeams)
                .flat()
                .filter(Boolean);

            try {
                const teamsResponse = await ResourceRequester.getList(
                    "dhbteam",
                    {
                        ids: missingTeamIds.join(","),
                        locale: locale,
                        ...(showArchived ? { excludeAllFilters: true } : {}),
                        flat: true,
                        fields: "name,ageGroup,league,season",
                        limit: 1000,
                    }
                );

                const teams = teamsResponse._embedded.dhbteam;

                showArchived && setAllTeamsLoaded(true);

                const managersResponse = await ResourceRequester.getList(
                    "contacts",
                    {
                        ids: allManagerIds.join(","),
                        locale: locale,
                        flat: true,
                        fields: "firstName,lastName",
                        limit: 1000,
                    }
                );

                const managers = managersResponse._embedded.contacts;

                const managersMap = managers.reduce((acc, manager) => {
                    acc[manager.id] = manager;
                    return acc;
                }, {});

                const teamsMap = teams.reduce((acc, team) => {
                    const teamManagers = selectedTeams[team.id] || [];
                    const managersForTeam = teamManagers.map(
                        (managerId) => managersMap[managerId] || {}
                    );

                    acc[team.id] = {
                        ...team,
                        managers: managersForTeam,
                    };

                    return acc;
                }, {});

                !showArchived && setActiveTeams(teamsMap);
                setTeamsData((prev) => ({
                    ...prev,
                    ...teamsMap,
                }));
            } catch (error) {
                console.error("Failed to fetch data:", error);
            } finally {
                setLoading(false);
            }
        };

        if (!allTeamsLoaded && !teamsData.length) {
            fetchAllData();
        }
    }, [showArchived]);

    if (loading) {
        return (
            <div className={styles["team-type"]}>
                <Loader />
            </div>
        );
    }

    return (
        <>
            {Object.entries(teamsData)
                .filter(([teamId]) => {
                    if (!showArchived) {
                        return Object.keys(activeTeams).includes(teamId);
                    }

                    return true;
                })
                .map(([teamId, team]) => {
                    return (
                        <Team
                            ageGroup={team.ageGroup ? team.ageGroup : "-"}
                            key={teamId}
                            teamId={teamId}
                            data={team.managers}
                            league={team.league ? team.league : "-"}
                            name={team.name}
                            season={team.season ? team.season : "-"}
                        />
                    );
                })}
        </>
    );
};

export default TeamType;
